import React from 'react'
import styled from 'styled-components'
import { TextCallout1 } from 'blocket-ui'
import { mediaQueries } from '@blazar-plugins/device'

const NUM_COLUMNS = 4

const Wrapper = styled.ul`
  @media ${mediaQueries.large} {
    padding: 8px 0;
    display: grid;
    grid-template-columns: repeat(${NUM_COLUMNS}, 1fr);
    border-top: 0.5px solid #efefef;
  }
`

const LoadingItem = styled(TextCallout1)`
  color: #f7f7f7;
  height: 33px;
  box-sizing: border-box;
  padding: 6px 16px;
  margin: 2px;
  border-radius: 4px;
  display: inline-block;
  width: 80px;
  line-height: inherit;

  animation-duration: 1.5s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-name: placeHolderShimmer;
  background: #f7f7f7;
  background: linear-gradient(to right, #f7f7f7 8%, #eeeeee 18%, #f7f7f7 33%);
  background-size: 800px 104px;
  position: relative;

  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }
`

const Loading = () => (
  <Wrapper>
    <LoadingItem tagName="li">&nbsp;</LoadingItem>
    <LoadingItem tagName="li" style={{ width: 100 }}>
      &nbsp;
    </LoadingItem>
    <LoadingItem tagName="li" style={{ width: 100 }}>
      &nbsp;
    </LoadingItem>
    <LoadingItem tagName="li" style={{ width: 120 }}>
      &nbsp;
    </LoadingItem>
    <LoadingItem tagName="li" style={{ width: 100 }}>
      &nbsp;
    </LoadingItem>
    <LoadingItem tagName="li" style={{ width: 120 }}>
      &nbsp;
    </LoadingItem>
    <LoadingItem tagName="li">&nbsp;</LoadingItem>
  </Wrapper>
)

export default Loading
